import React, { useRef, useState, useEffect } from "react";
import {
  Button,
} from "react-bootstrap";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import moment from "moment";
import 'moment/locale/id';
const numberFormat = (value) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);


function Test({ item }) {

  const [datas, setDatas] = React.useState([]);
  const [objnew, setObjNew] = React.useState([]);
  let [branch, setBranch] = React.useState("");
  let [firstDate, setFD] = React.useState("");
  let [lastDate, setLD] = React.useState("");
  let [singleDate, setSD] = React.useState(false);

  useEffect(() => {

    const _datas = item.data.sort(function (a, b) {
      return a.branch_id - b.branch_id;
    });
    
    
        if (_datas.length > 1) {
        if (_datas[1].branch_id){
               setSD(false);
        }else{
               setSD(true);
        }

    }else{
    setSD(true);
    }
    

    let len = _datas.length;
    let first_value = _datas[0];
    let last_value = _datas[len - 1];

    setFD(moment(moment.utc(first_value.TGL_LAYANAN)).local().format("DD/MM/YYYY"));
    setLD(moment(moment.utc(last_value.TGL_LAYANAN)).local().format("DD/MM/YYYY"));


    const unique = [
      ...new Set(_datas.map((item) => item.branch_id)),
    ];

    const rowLen = unique.length;
    let obj = "";
    unique.map(function (key, i) {
      if (rowLen === i + 1) {
        obj = obj + (key + ":[]");
      } else {
        obj = obj + (key + ":[],");
      }
    });

    let obj_ = "{" + obj + "}";
    let jsonStr = obj_.replace(/(\w+:)|(\w+ :)/g, function (matchedStr) {
      return '"' + matchedStr.substring(0, matchedStr.length - 1) + '":';
    });


    console.log("jsonStr", jsonStr);

    let obj_new = JSON.parse(jsonStr);
    unique.map(function (key, i) {
      let obj_array = [];
      let obj_key = '';
      _datas.map(function (i) {
        if (i["branch_id"] == key) {

          let z = {
            "ID_REGISTRASI": i["ID_REGISTRASI"],
            "NOMR": i["NOMR"],
            "NOREG": i["NOREG"],
            "DATE_REGISTRASI": i["DATE_REGISTRASI"],
            "NAMA_PASIEN": i["NAMA_PASIEN"],
            "NAMA_DOKTER": i["NAMA_DOKTER"],
            "TGL_LAYANAN": i["TGL_LAYANAN"],
            "STATUS": i["STATUS"],
            "PEMBAYARAN_KONSULTASI": i["PEMBAYARAN_KONSULTASI"],
            "PEMBAYARAN_DISKON": i["PEMBAYARAN_DISKON"],
            "name": i["name"],
            "branch_id": i["branch_id"],
            "branch_name": i["branch_name"],
            "KODE_KONSULTASI": i["KODE_KONSULTASI"],
            "NAMA_KONSULTASI": i["NAMA_KONSULTASI"],
            "KATEGORI_KONSULTASI": i["KATEGORI_KONSULTASI"],
            "HARGA_KONSULTASI": i["HARGA_KONSULTASI"],
            "DATE_PEMBAYARAN": i["DATE_PEMBAYARAN"],
            "METODE_PEMBAYARAN": i["METODE_PEMBAYARAN"],
            "TOTAL_HARGA": i["TOTAL_HARGA"],
            "STATUS_PEMBAYARAN": i["STATUS_PEMBAYARAN"]
          }

          obj_array.push(z);
          console.log("sama", z);
          obj_key = key;

        }
      });

      const _datas2 = obj_array.sort(function (a, b) {
        return a.order - b.order;
      });

      _datas2.map(function (item) {
        obj_new[obj_key].push(item);
      });

      console.log("obj_new", obj_new);

    });

    setDatas(_datas);
    setObjNew(obj_new);

    console.log("INI PROPS DOWNLOAD EXCEL", obj_new)

  }, []);

  const tableRef = useRef(null);

  const returnHTML = () => {

    let stringHTML = "";
    let allTotal = 0;
    Object.keys(objnew).map(function (key) {
      let x = objnew[key];
      let z = datas.find(el => el.branch_id == key);

      if (z.branch_name) {
        stringHTML += '<tr>';
        stringHTML += "<td colSpan='10' style='background-color: black; color : white; font-weight:bold'>" + z.branch_name + "</td>";
        stringHTML += '</tr>';
      }

      stringHTML += '<tr>'+
      '<th>TGL LAYANAN</th>'+
      '<th>STATUS</th>'+
      '<th>NAMA PASIEN</th>'+
      '<th>NAMA DOKTER</th>'+
      '<th>METODE PEMBAYARAN</th>'+
      '<th>BRUTO</th>'+
      '<th>DISKON %</th>'+
      '<th>NOMINAL KONSULTASI</th>'+
      '<th>NOMINAL DOKTER</th>'+
      '<th>TOTAL HARGA</th>'+
      '</tr>';

      let totalKonsultasi = 0;
      let totalDokter = 0;
      let totalHarga = 0;

      x.map((item, i) => {


        let col6 = "";
        if (item.PEMBAYARAN_KONSULTASI == 0) {
          col6 = "-";
        } else if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          col6 = "FREE";
        } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          col6 = item.PEMBAYARAN_DISKON + "%";
        } else {
          col6 = null;
        }

        let col7 = "";
        if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          col7 = "0";
        } else if (item.PEMBAYARAN_KONSULTASI == 0) {
          col7 = item.HARGA_KONSULTASI - ((25 / 100) * item.HARGA_KONSULTASI);
        } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          col7 = (item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI)) - ((25 / 100) * (item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI)));
        } else {
          col7 = null;
        }

        let col8 = "";
        if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          col8 = "0";
        } else if (item.PEMBAYARAN_KONSULTASI == 0) {
          col8 = (25 / 100) * item.TOTAL_HARGA;
        } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          col8 = ((25 / 100) * (item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI)));
        } else {
          col8 = null;
        }

        let num = 0;
        let num2 = 0;
        let num3 = 0;

        if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          num = 0;
          num2 = 0;
          num3 = 0;
        } else if (item.PEMBAYARAN_KONSULTASI == 0) {
          num = Number(item.HARGA_KONSULTASI - ((25 / 100) * item.HARGA_KONSULTASI));
          num2 = Number((25 / 100) * item.TOTAL_HARGA);
          num3 = Number(item.TOTAL_HARGA);

        } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          let _step1 = item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI);
          num = Number(_step1 - ((25 / 100) * _step1));

          let _step2 = item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI);
          num2 = Number((25 / 100) * _step2);
          num3 = Number(item.TOTAL_HARGA);

        } else {
          num = 0;
          num2 = 0;
          num3 = 0;
        }

        totalKonsultasi = totalKonsultasi + num;
        totalDokter = totalDokter + num2;
        totalHarga = totalHarga + num3

        stringHTML += '<tr>' +
          '<td style="text-align:left">' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
          '<td>' + item.STATUS + '</td>' +
          '<td>' + item.NAMA_PASIEN + '</td>' +
          '<td>' + item.NAMA_DOKTER + '</td>' +
          '<td>' + item.METODE_PEMBAYARAN + '</td>' +
          '<td>' + item.HARGA_KONSULTASI + '</td>' +
          '<td style="text-align:center;">' + col6 + '</td>' +
          '<td>' + col7 + '</td>' +
          '<td>' + col8 + '</td>' +
          '<td>' + item.TOTAL_HARGA + '</td>' +
          '</tr >'


      });



      stringHTML += '<tr>' +
        "<td style='background-color:#90EE90'></td>" +
        "<td style='background-color:#90EE90'></td>" +
        "<td style='background-color:#90EE90'></td>" +
        "<td style='background-color:#90EE90'></td>" +
        "<td style='background-color:#90EE90'></td>" +
        "<td style='background-color:#90EE90'></td>" +
        "<td style='background-color:#90EE90'><b>TOTAL</b></td>" +
        "<td style='background-color:#90EE90'><b>" + totalKonsultasi + "</b></td>" +
        "<td style='background-color:#90EE90'><b>" + totalDokter + "</b></td>" +
        "<td style='background-color:#90EE90'><b>" + totalHarga + "</b></td>" +
        '</tr >'


      stringHTML += '<tr>' +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        "<td ></td>" +
        '</tr >'

      allTotal = allTotal + totalHarga;

    })


    stringHTML += '<tr>' +
      "<td style='background-color:#339966;color:white'></b></td>" +
      "<td style='background-color:#339966;color:white'></b></td>" +
      "<td style='background-color:#339966;color:white'></b></td>" +
      "<td style='background-color:#339966;color:white'></b></td>" +
      "<td style='background-color:#339966;color:white'></b></td>" +
      "<td style='background-color:#339966;color:white'></b></td>" +
      "<td style='background-color:#339966;color:white' colSpan='3'><b>TOTAL KESELURUHAN</b></td>" +
      "<td style='background-color:#339966;color:white'><b>" + allTotal + "</b></td>" +
      '</tr >'

    return stringHTML
  };

  return (
    <div>
      <DownloadTableExcel
        filename={"report_" + new Date().toISOString().slice(0, 10) + "_" + (Math.random() + 1).toString(36).substring(7)}
        sheet="report"
        currentTableRef={tableRef.current}
      >

        <Button
          className="button-block btn-success"
          // style={{ zIndex: 99, marginLeft: '-14px', width: '120px', marginTop: '4px' }}
          style={{ zIndex: 99, width: '100%', marginTop: '4px' }}
        >
          Export excel
        </Button>


        {/* <button> Export excel </button> */}

      </DownloadTableExcel>


      {/* <p>{JSON.stringify(item.data)}</p> */}



      <table
        ref={tableRef}
        className='hide-print'
      >
        <tbody>
          <tr>
          
          {singleDate ? (
          <th colSpan={10}><p style={{ fontSize: '22px', textAlign: 'left' }}>REKAPITULASI PENERIMAAN KLINIK PERIODE {lastDate}</p></th>
          ) : (
          
          <th colSpan={10}><p style={{ fontSize: '22px', textAlign: 'left' }}>REKAPITULASI PENERIMAAN KLINIK PERIODE {lastDate} - {firstDate}</p></th>
          )}
            
          </tr>


          {datas.length > 0 ? ReactHtmlParser(returnHTML())
            : null}


        </tbody>
      </table>

    </div>
  );
}


export default Test